<!-- 关联信息 -->
<template>
  <div class="relates-info-view">
    <p class="info-title">智参企业信息&nbsp;&nbsp;{{ zcCompanyList.length }}</p>

    <div class="table-box ly_table_light ">
      <el-table
        :data="zcCompanyList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column label="智参企业编号" prop="companyCode" align="center"> </el-table-column>

        <el-table-column label="智参企业名称" prop="companyFullName" align="center"> </el-table-column>
      </el-table>
    </div>

    <p class="info-title">数智企业信息&nbsp;&nbsp;{{ szCompanyList.length }}</p>

    <div class="table-box ly_table_light ">
      <el-table
        :data="szCompanyList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column label="数智企业编号" prop="companyCode" align="center"> </el-table-column>

        <el-table-column label="数智企业名称" prop="companyFullName" align="center"> </el-table-column>
      </el-table>
    </div>

    <p class="info-title">关联产品信息&nbsp;&nbsp;{{ productList.length }}</p>

    <div class="table-box ly_table_light ">
      <el-table
        :data="productList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column label="关联产品编号" prop="productCode" align="center"> </el-table-column>

        <el-table-column label="关联产品名称" prop="productName" align="center"> </el-table-column>
      </el-table>
    </div>

    <p class="info-title">解决方案信息&nbsp;&nbsp;{{ solutionList.length }}</p>

    <div class="table-box ly_table_light ">
      <el-table
        :data="solutionList"
        border
        style="width: 650px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell"
      >
        <el-table-column label="解决方案编号" prop="solutionCode" align="center"> </el-table-column>

        <el-table-column label="解决方案名称" prop="solutionName" align="center"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// api
import { getReportRelationInfo } from "@/api/report.js";

export default {
  data() {
    //这里存放数据
    return {
      productList: [], // 产品
      szCompanyList: [], // 数智企业
      zcCompanyList: [], // 智参企业
      solutionList: [] // 解决方案
    };
  },
  methods: {
    getInfo() {
      getReportRelationInfo({
        reportId: this.$route.query.reportId
      }).then(res => {
        if (res.code == 200 && res.data) {
          if (Array.isArray(res.data.productList)) {
            this.productList = res.data.productList;
          }

          if(Array.isArray(res.data.szCompanyList)) {
            this.szCompanyList = res.data.szCompanyList;
          }

          if(Array.isArray(res.data.zcCompanyList)) {
            this.zcCompanyList = res.data.zcCompanyList;
          }

          if(Array.isArray(res.data.solutionList)) {
            this.solutionList = res.data.solutionList;
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.relates-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;
  }
}
</style>